import { Toaster } from "components/notification/Toaster";
import useReporting from "dataflow/billingPortal/actions/useReporting.actions";
import { isArrayNotEmpty } from "functions";
import { useCustomSelector } from "hooks";
import { useEffect, useRef, useState } from "react";


export function useUpdate({
    currentTabId, enabledProductList, commission
}) {
    const totalSuccessfulUpdatesLeft = useRef(0);
    const [deletionList, setDeletionList] = useState([]);
    const [additionList, setAdditionList] = useState([]);
    const [isUpdateDisabled, setIsUpdateDisabled] = useState(true);
    const [isMounted, setIsMounted] = useState();

    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");

    const {
        level1EnabledProductDetailList, level2EnabledProductDetailList, level2CommissionPercentage,
        addProductLevel1_isSuccessful, addProductLevel2_isSuccessful,
        deleteProductLevel1_isSuccessful, deleteProductLevel2_isSuccessful,
        updateLevel2CommissionPercentage_isSuccessful,

        addProductLevel1_requesting, addProductLevel2_requesting,
        deleteProductLevel1_requesting, deleteProductLevel2_requesting
    } = useCustomSelector("reporting");

    const {
        addProductLevel1, addProductLevel2, 
        deleteProductLevel1, deleteProductLevel2, updateLevel2CommissionPercentage
    } = useReporting();

    let isNewOutlet = (currentTabId === "newOutlet");
    let originalEnabledList = isNewOutlet? level1EnabledProductDetailList: level2EnabledProductDetailList;
    let addProduct_isSuccessful = isNewOutlet? addProductLevel1_isSuccessful: addProductLevel2_isSuccessful;
    let deleteProduct_isSuccessful = isNewOutlet? deleteProductLevel1_isSuccessful: deleteProductLevel2_isSuccessful;
    let addProduct_requesting = isNewOutlet? addProductLevel1_requesting: addProductLevel2_requesting;
    let deleteProduct_requesting = isNewOutlet? deleteProductLevel1_requesting: deleteProductLevel2_requesting;
    let addProduct = isNewOutlet? addProductLevel1: addProductLevel2;
    let deleteProduct = isNewOutlet? deleteProductLevel1: deleteProductLevel2;


    // Reset when tab change.
    useEffect(() => {
        setDeletionList([]);
        setAdditionList([]);
        setIsUpdateDisabled(true);
        totalSuccessfulUpdatesLeft.current = 0;
    }, [currentTabId]);

    function successfulMsgDisplay(isSuccessful) {
        if (isSuccessful && totalSuccessfulUpdatesLeft.current == 1) {
            Toaster({
                type: "success",
                msg: "Update successful"
            });

            totalSuccessfulUpdatesLeft.current = totalSuccessfulUpdatesLeft.current - 1;
            setIsUpdateDisabled(true);
        }
        else if (totalSuccessfulUpdatesLeft.current > 1) {
            totalSuccessfulUpdatesLeft.current = totalSuccessfulUpdatesLeft.current - 1;
        }
    }
    useEffect(() => {
        successfulMsgDisplay(addProduct_isSuccessful);
    }, [addProduct_isSuccessful]);
    useEffect(() => {
        successfulMsgDisplay(deleteProduct_isSuccessful);
    }, [deleteProduct_isSuccessful]);
    useEffect(() => {
        successfulMsgDisplay(updateLevel2CommissionPercentage_isSuccessful);
    }, [updateLevel2CommissionPercentage_isSuccessful]);

    useEffect(() => {
        // get list of deleted products
        let isDisabled = true;
        if (isArrayNotEmpty(originalEnabledList)) {
            let deletionList = [];
            originalEnabledList.map((details) => {
                // find match
                let isMatchFound = false;
                if (isArrayNotEmpty(enabledProductList)) {
                    enabledProductList.map((groups) => {
                        // Go through sub list
                        let subList = groups?.subList;
                        if (isArrayNotEmpty(subList)) {
                            subList.map((currentDetails) => {
                                let label = currentDetails?.label;
                                let data = label.split(" - ");
                                if (data.length == 2) {
                                    let productName = data[0];
                                    let productCode = data[1];

                                    if (productName == details?.ProductName &&
                                        productCode == details?.ProductCode) {
                                        isMatchFound = true;
                                    }
                                }
                            })
                        }
                    });
                }

                if (!isMatchFound) {
                    deletionList.push(details?.Id);
                }
            });

            if (isArrayNotEmpty(deletionList)) {
                isDisabled = false;
                setDeletionList(deletionList);
            }
        }

        // get list of addition products
        if (isArrayNotEmpty(enabledProductList)) {
            let additionList = [];
            enabledProductList.map((group) => {
                // find match
                let subList = group?.subList;
                if (isArrayNotEmpty(subList)) {
                    subList.map((currentDetails) => {
                        let label = currentDetails?.label;
                        let data = label.split(" - ");
                        let isMatchFound = false;

                        if (data.length == 2) {
                            let productName = data[0];
                            let productCode = data[1];

                            if (isArrayNotEmpty(originalEnabledList)) {
                                originalEnabledList.map((details) => {
                                    if (productName == details?.ProductName &&
                                        productCode == details?.ProductCode) {
                                        isMatchFound = true;
                                    }
                                });
                            }

                            if (!isMatchFound) {
                                additionList.push({
                                    ProductName: productName,
                                    ProductCode: productCode
                                });
                            }
                        }
                    })
                }
            });
            
            if (isArrayNotEmpty(additionList)) {
                isDisabled = false;
                setAdditionList(additionList);
            }
        }

        // Update commission
        if (commission != level2CommissionPercentage) {
            isDisabled = false;
        }

        setIsUpdateDisabled(isDisabled);
    }, [commission, JSON.stringify(enabledProductList)]);

    function updateProductDetails() {
        function updateTotalSuccess() {
            if (totalSuccessfulUpdatesLeft.current < 1)
                totalSuccessfulUpdatesLeft.current = totalSuccessfulUpdatesLeft.current  + 1;
        }

        if (isArrayNotEmpty(deletionList)) {
            if (userPermissions?.Internal_DealerReport_Delete) {
                updateTotalSuccess();
                deleteProduct(deletionList, "Dealer");
            }
            else {
                Toaster({
                    type: "error",
                    msg: "'Internal Report Delete' permission required"
                })
            }
        }

        if (isArrayNotEmpty(additionList)) {
            if (userPermissions?.Internal_DealerReport_Add) {
                updateTotalSuccess();
                addProduct(additionList, "Dealer");
            }
            else {
                Toaster({
                    type: "error",
                    msg: "'Internal Report Add' permission required"
                })
            }
        }

        // Update commission
        if (commission != level2CommissionPercentage) {
            if (userPermissions?.Internal_DealerReport_Add) {
                updateTotalSuccess();
                updateLevel2CommissionPercentage(commission, "Dealer");
            }
            else {
                Toaster({
                    type: "error",
                    msg: "'Internal Report Add' permission required"
                })
            }
        }
    }

    return {
        updateProductDetails,
        isUpdateDisabled,

        addProduct_requesting,
        deleteProduct_requesting
    }
}